module.exports = __webpack_public_path__ + "c5c7fb8672356180b0c34b66b474aec8.jpg";